/* DN5 · BESTSELLER badge (Edward 2026-10-31: no product tags; the theme works it out from Shopify).
   A card shows its badge when its product is in the store's top N by Shopify's own best-selling sort.
   The list comes from templates/collection.dn5bs.liquid (/collections/all?sort_by=best-selling&view=dn5bs);
   N lives in snippets/dn5-merch-rule. Cards carry the slot: <span data-dn-bs="<product id>" data-dn-bs-label="...">.
   Cached per browser tab for 30 minutes (sessionStorage). Fetch fails / wrong sort -> no BESTSELLER badge, never a guess.
   Cards added later (section re-render, load more, pinned cards) are painted by the MutationObserver. */
(function () {
  if (window.__dn5bs) return; window.__dn5bs = 1;
  var KEY = 'dn5bs:v1', TTL = 30 * 60 * 1000, ids = null;

  function cached() {
    try {
      var o = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (o && Array.isArray(o.ids) && Date.now() - o.t < TTL) return o.ids;
    } catch (e) {}
    return null;
  }
  function paintOne(el) {
    if (ids.indexOf(String(el.getAttribute('data-dn-bs'))) === -1) return;
    var label = el.getAttribute('data-dn-bs-label');
    if (!label) return;
    el.textContent = label;
    el.style.display = '';
    el.setAttribute('data-dn-bs-on', '1');
  }
  function paint(scope) {
    if (!ids || !scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('[data-dn-bs]')) paintOne(scope);
    scope.querySelectorAll('[data-dn-bs]').forEach(paintOne);
  }
  function load() {
    ids = cached();
    if (ids) { paint(document); return; }
    var route = typeof window.dnRoute === 'function' ? window.dnRoute : function (p) { return '/' + p; };
    fetch(route('collections/all?sort_by=best-selling&view=dn5bs'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || d.sort !== 'best-selling' || !Array.isArray(d.ids)) return;
        ids = d.ids.map(String);
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), ids: ids })); } catch (e) {}
        paint(document);
      })['catch'](function () {});
  }
  new MutationObserver(function (list) {
    if (!ids) return;
    for (var i = 0; i < list.length; i++) {
      var added = list[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) paint(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
